import { placeTree } from "./places";
export function directoryTree(directory) {
    const companies = new Map(directory.companies.map((c) => [c.id, c]));
    const premises = new Map(directory.premises.map((p) => [p.id, p]));
    return placeTree({
        nendaCompanyId: directory.nendaCompanyId,
        premiseOfUnit: () => null,
        companyOfPremise: (id) => { var _a; return (_a = premises.get(id)) === null || _a === void 0 ? void 0 : _a.companyId; },
        parentOfCompany: (id) => { var _a; return (_a = companies.get(id)) === null || _a === void 0 ? void 0 : _a.parentId; },
    });
}
export function placeName(directory, place) {
    var _a, _b, _c, _d;
    if (place.kind === "company") {
        if (place.id === directory.nendaCompanyId)
            return "Nenda";
        return (_b = (_a = directory.companies.find((c) => c.id === place.id)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : place.id;
    }
    return (_d = (_c = directory.premises.find((p) => p.id === place.id)) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : place.id;
}
